import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-100 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-3xl" aria-hidden="true"></i>
      </span>
      <h1 className="mt-5 font-heading text-4xl font-bold text-foreground-950 md:text-5xl">
        页面走丢了
      </h1>
      <p className="mt-3 text-base text-foreground-500">
        你访问的页面不存在或已被移除，换个地方看看吧。
      </p>
      <Link
        to="/"
        className="mt-6 flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
      >
        <i className="ri-home-5-line" aria-hidden="true"></i>
        返回首页
      </Link>
    </div>
  );
}